import { Loader2 } from 'lucide-react';

/**
 * PageLoader - A lightweight, premium-branded loading fallback for lazy-loaded routes
 * Used with React.lazy() and Suspense for code-split pages
 */
const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center bg-background">
    <div className="flex flex-col items-center gap-4">
      <Loader2 className="w-8 h-8 text-accent animate-spin" aria-hidden="true" />
      <span className="sr-only">Loading page...</span>
    </div>
  </div>
);

export default PageLoader;
